import AnalyticsDashboard from '@/components/analytics/AnalyticsDashboard'

const Analytics: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Platform Analytics</h1>
        <p className="text-gray-600 mt-1">View platform-wide analytics and insights</p>
      </div>
      
      <AnalyticsDashboard isAdmin={true} />
    </div>
  )
}

export default Analytics 